module.exports = __webpack_public_path__ + "static/media/gn.dab67d0c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gn.svg
// module id = 2102
// module chunks = 0